import React from "react";

const CompanySkeleton = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 animate-pulse">
      {/* Column 1: Value, Ownership, Ownership Type */}
      <div className="space-y-5">
        <div className="flex items-baseline gap-16 justify-between w-fit">
          <div className="h-4 w-16 bg-gray-300 dark:bg-gray-700 rounded"></div>
          <div className="h-6 w-24 bg-gray-300 dark:bg-gray-700 rounded"></div>
        </div>
        <div className="flex items-baseline gap-12 justify-between w-fit">
          <div className="h-4 w-20 bg-gray-300 dark:bg-gray-700 rounded"></div>
          <div className="h-6 w-16 bg-gray-300 dark:bg-gray-700 rounded"></div>
        </div>
        <div className="flex items-baseline gap-4 justify-between w-fit">
          <div className="h-4 w-28 bg-gray-300 dark:bg-gray-700 rounded"></div>
        </div>
      </div>

      {/* Column 2: CRR, ROI */}
      <div className="space-y-5">
        <div className="flex items-baseline gap-3 justify-between w-fit">
          <div className="h-4 w-12 bg-gray-300 dark:bg-gray-700 rounded"></div>
          <div className="h-6 w-20 bg-gray-300 dark:bg-gray-700 rounded"></div>
        </div>
        <div className="flex items-baseline gap-5 justify-between w-fit">
          <div className="h-4 w-10 bg-gray-300 dark:bg-gray-700 rounded"></div>
          <div className="h-6 w-14 bg-gray-300 dark:bg-gray-700 rounded"></div>
        </div>
      </div>

      {/* Column 3: Realised, Unrealised, Market Value */}
      <div className="space-y-3">
        <div className="flex justify-between items-baseline w-fit gap-10">
          <div className="h-4 w-28 bg-gray-300 dark:bg-gray-700 rounded"></div>
          <div className="h-6 w-20 bg-gray-300 dark:bg-gray-700 rounded"></div>
        </div>
        <div className="flex justify-between items-baseline w-fit gap-6">
          <div className="h-4 w-32 bg-gray-300 dark:bg-gray-700 rounded"></div>
          <div className="h-6 w-20 bg-gray-300 dark:bg-gray-700 rounded"></div>
        </div>
        <div className="flex justify-between items-baseline w-fit gap-10">
          <div className="h-4 w-28 bg-gray-300 dark:bg-gray-700 rounded"></div>
          <div className="h-6 w-20 bg-gray-300 dark:bg-gray-700 rounded"></div>
        </div>
      </div>

      {/* Column 4: Income, Expense, EBITDA Multiples */}
      <div className="space-y-3">
        <div className="flex justify-between items-baseline w-fit gap-12">
          <div className="h-4 w-20 bg-gray-300 dark:bg-gray-700 rounded"></div>
          <div className="h-6 w-20 bg-gray-300 dark:bg-gray-700 rounded"></div>
        </div>
        <div className="flex justify-between items-baseline w-fit gap-12">
          <div className="h-4 w-20 bg-gray-300 dark:bg-gray-700 rounded"></div>
          <div className="h-6 w-20 bg-gray-300 dark:bg-gray-700 rounded"></div>
        </div>
        <div className="flex justify-between items-baseline w-fit gap-4">
          <div className="h-4 w-28 bg-gray-300 dark:bg-gray-700 rounded"></div>
          <div className="h-6 w-20 bg-gray-300 dark:bg-gray-700 rounded"></div>
        </div>
      </div>
    </div>
  );
};

export default CompanySkeleton;
